import { useAuth } from 'wasp/client/auth';
import { FC, ReactNode, memo, useMemo } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import CommonLayout from '../../components/layout/CommonLayout';
import '../admin-theme.css';
import { taxonomyLayoutConfig } from './taxonomyConfig';
import { isAdministrator } from '../../client/lib/platformRole';
import { TopBarContentProvider, useTopBarContent } from '../../client/contexts/TopBarContentContext';

interface Props {
  // user prop kept for backward-compatibility with pages that still pass it;
  // the layout fetches the real user itself via useAuth so the sidebar never remounts.
  user?: { platformRole?: string };
  children?: ReactNode;
}

const TaxonomyLayoutInner: FC<{ children?: ReactNode }> = ({ children }) => {
  const { data: user } = useAuth();
  const { topBarContent } = useTopBarContent();

  const config = useMemo(() => ({
    ...taxonomyLayoutConfig,
    customTopBarContent: topBarContent ?? undefined,
  }), [topBarContent]);

  if (!user) return null;

  if (!isAdministrator(user)) {
    return <Navigate to='/' replace />;
  }

  return (
    <div className="admin-surface">
      <CommonLayout config={config}>
        <div className="w-full">
          {children ?? <Outlet />}
        </div>
      </CommonLayout>
    </div>
  );
};

const TaxonomyLayout: FC<Props> = memo(({ children }) => {
  return (
    <TopBarContentProvider>
      <TaxonomyLayoutInner>{children}</TaxonomyLayoutInner>
    </TopBarContentProvider>
  );
});

TaxonomyLayout.displayName = 'TaxonomyLayout';

export default TaxonomyLayout;



